import { images } from '../assets/images';

const About = () => {
  return (
    <div className="pt-16 pb-24">
      {/* Header */}
      <div className="bg-slate-900 text-white py-20 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">About Us</h1>
        <p className="text-slate-400 max-w-2xl mx-auto px-4">Building the future of industrial electronics with precision and quality.</p>
      </div>

      <div className="container mx-auto px-4 mt-16">
        {/* Company Profile */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-24">
          <div>
            <img 
              src={images.about} 
              alt="Company Factory" 
              className="rounded-lg shadow-xl w-full h-[400px] object-cover"
            />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Company Profile</h2>
            <p className="text-slate-600 mb-4 leading-relaxed">
              ElectroMfg Corp is a leading manufacturer of high-quality electrical and electronic components. 
              Established in 1995, we have grown from a small workshop to a state-of-the-art manufacturing facility 
              serving clients globally.
            </p>
            <p className="text-slate-600 leading-relaxed">
              Our commitment to quality and innovation has made us a trusted partner for major industries including 
              automotive, aerospace, and consumer electronics. We pride ourselves on our rigorous testing standards 
              and sustainable manufacturing practices.
            </p>
          </div>
        </div>

        {/* Vision & Mission */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-24">
          <div className="bg-slate-50 p-8 rounded-lg border-l-4 border-orange-500">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">Our Vision</h3>
            <p className="text-slate-600">
              To be the global benchmark for quality and innovation in the electrical manufacturing industry, 
              empowering industries with reliable and efficient power solutions.
            </p>
          </div>
          <div className="bg-slate-50 p-8 rounded-lg border-l-4 border-slate-900">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">Our Mission</h3>
            <p className="text-slate-600">
              To deliver superior electrical products through continuous innovation, operational excellence, 
              and a customer-centric approach, while maintaining the highest standards of safety and sustainability.
            </p>
          </div>
        </div>

        {/* Infrastructure */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">Our Infrastructure</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <img src={images.hero[0]} alt="Factory" className="rounded-lg shadow-md h-64 w-full object-cover" />
            <img src={images.hero[2]} alt="Process" className="rounded-lg shadow-md h-64 w-full object-cover" />
            <img src={images.applications.lighting} alt="Lighting" className="rounded-lg shadow-md h-64 w-full object-cover" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
